import http from './http';

export async function listStudents(params) {
  const { data } = await http.get('/students', { params });
  return data;
}

export async function createStudent(payload) {
  const { data } = await http.post('/students', payload);
  return data;
}

export async function updateStudent(id, payload) {
  const { data } = await http.put(`/students/${id}`, payload);
  return data;
}

export async function deleteStudent(id) {
  await http.delete(`/students/${id}`);
}

// Self-service (student)
export async function getMyStudent() {
  const { data } = await http.get('/students/me');
  return data;
}

export async function updateMyStudent(payload) {
  const { data } = await http.put('/students/me', payload);
  return data;
}

export async function resetStudentPassword(studentId) {
  const { data } = await http.post(`/students/${studentId}/reset-password`);
  return data;
}

export async function getStudentAssignmentsHistory(studentId) {
  const { data } = await http.get(`/students/${studentId}/room-assignments`);
  return data;
}
